<!-- =========================================================================================
  File Name: usersView.vue
  Description: Team Information
  ----------------------------------------------------------------------------------------
  Item Name: KOZO Admin - VueJS Dashboard
  Author:
  Author URL:
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <div class="vx-row">
      <div class="vx-col w-full">
        <router-link to="/apps/projects">
          <feather-icon icon="ArrowLeftCircleIcon" svgClasses="h-8 w-8" />
        </router-link>
      </div>
      <!-- USERS FORMS -->
      <div
        v-if="
          permissionPageAccessArry.includes(PermissionVariables.UserAdd) ||
            loginUserRole == 'Admin'
        "
        class="vx-col w-full mb-base"
      >
        <users-form></users-form>
      </div>

      <div class="vx-col w-full">
        <!-- USERS LIST -->
        <vs-tabs>
          <vs-tab
            v-if="
              permissionPageAccessArry.includes(PermissionVariables.UserView) ||
                permissionPageAccessArry.includes(
                  PermissionVariables.UserDelete
                ) ||
                permissionPageAccessArry.includes(
                  PermissionVariables.UserEdit
                ) ||
                permissionPageAccessArry.includes(
                  PermissionVariables.UserExport
                ) ||
                loginUserRole == 'Admin'
            "
            label="Users List"
            icon-pack="feather"
            icon="icon-box"
          >
            <div class="tab-text">
              <!-- USERS LIST -->
              <div>
                <users-list></users-list>
              </div>
            </div>
          </vs-tab>
          <!--   <vs-tab label="Archive List" icon-pack="feather" icon="icon-box">
            <div>
              <users-list listType="archive"></users-list>
            </div>
          </vs-tab>-->
        </vs-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import usersForm from "@/views/apps/users/usersForm.vue";
import usersList from "@/views/apps/users/usersList.vue";
import PermissionVariables from "@/services/UserManagementVaraibles.js";

export default {
  data() {
    return {
      permissionPageAccessArry: window.localStorage.getItem(
        "permissionPageAccess"
      )
        ? localStorage.getItem("permissionPageAccess").split(",")
        : "",
      isActive: false,
      // analyticsData: analyticsData,
      isImp: false,
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      PermissionVariables: PermissionVariables,
      loginUserRole: window.localStorage.getItem("UserRole"),
      show: false,
      items: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      nextNum: 10,
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot"
      ]
    };
  },
  methods: {
    myFilter: function() {
      this.isActive = !this.isActive;
    }
  },
  components: {
    usersForm,
    usersList
  }
};
</script>

<style lang="scss">
#dashboard-analytics {
  .greet-user {
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
</style>
